module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar2"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "ch01sub3"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("TIME")])])]), _c('a', {
    attrs: {
      "id": "ch01sub3"
    }
  }), _c('h2', {
    staticClass: "h2tit"
  }, [_c('a', {
    attrs: {
      "id": "ch01sub3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Gimmie a Beat")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Time is a fundamental aspect of music theory that is often left out of formal music-theory study. Time is more than just counting beats and bars. Time can dictate the feel and flow of a piece; even harmony has a rhythm to it, aptly called harmonic rhythm. You’ll start with time signatures, as they are the first time-related aspect you need to understand in detail.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("TIME SIGNATURES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Music is divided into bars, or measures, for reading convenience and for musical purposes. Most music adheres to a meter, which affects the phrasing of the melody. If you don’t have a lot of experience reading music, rhythm can be a very difficult concept to grasp.")]), _vm._v(" "), _c('p', {
    staticClass: "boxhead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Notable")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "boxtxt"
  }, [_vm._v("A beat is a way of counting time when playing music. Beats are grouped together in a measure (the notes and rests that correspond to a certain number of beats). The grouping of strong and weak beats is called meter. You can find the meter signature (also called the time signature) at the beginning of every piece of music.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("The most standard time signature is "), _c('img', {
    staticClass: "midd",
    attrs: {
      "alt": "images",
      "src": "images/4by4.jpg"
    }
  }), _vm._v(" time, which is also called common time and is abbreviated by this symbol: "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/c.jpg"
    }
  }), _vm._v(". Common time looks like a fraction and signifies two things. First, the top number 4 means that every measure will have four beats in it. The bottom number 4 indicates what note value will receive the beat; in this case, 4 stands for a quarter note ("), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-02.jpg"
    }
  }), _vm._v("). So common time breaks up each measure into four beats, as a quarter note receives one beat. You can, of course, further divide the ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("measure into as many small parts as you like, but in the end, it must still add up to four beats.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("RHYTHM")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Music is composed of pitch and rhythm. Although finer elements come into play later on, such as dynamics and expression, music can be made simply by knowing which note and how long to hold it. Without rhythm, people couldn’t fully read music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rhythm is music’s way of setting the duration of a note. Music accomplishes this task by varying the appearance of the notes that sit on the staff. Different rhythms indicate different note lengths. To get rolling, you need to hear about an essential concept: beat. Have you ever been to a concert and clapped along with 30,000 other fans? Have you noticed how everyone claps together in a steady pattern? Did you ever wonder how 30,000 people could possibly agree on anything? If you’ve been to a dance club, you may have noticed that there is always a steady drumbeat or bass line, usually up-tempo, to drive the music along. Those are examples of pulse and beat in music. Rhythm is a primal element, and pulse and beat are universal concepts.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0387694c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01c.vue
// module id = 81
// module chunks = 0